const sampleProducts = [
  {
    "name": "2D Wardrobe - A",
    "sku": "0101",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0101.png",
    "default_height": 2100,
    "default_width": 900
  },
  {
    "name": "2D Wardrobe - B",
    "sku": "0102",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0102.png",
    "default_height": 2100,
    "default_width": 900
  },
  {
    "name": "2D Wardrobe - C",
    "sku": "0103",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0103.png",
    "default_height": 2100,
    "default_width": 900
  },
  {
    "name": "2D Wardrobe - D",
    "sku": "0104",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0104.png",
    "default_height": 2100,
    "default_width": 900
  },
  {
    "name": "2D Wardrobe - E",
    "sku": "0105",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0105.png",
    "default_height": 2100,
    "default_width": 900
  },
  {
    "name": "2D Wardrobe - F",
    "sku": "0106",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0106.png",
    "default_height": 2100,
    "default_width": 900
  },
  {
    "name": "2D Wardrobe - G",
    "sku": "0107",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0107.png",
    "default_height": 2100,
    "default_width": 900
  },
  {
    "name": "2D Wardrobe - H",
    "sku": "0108",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0108.png",
    "default_height": 2100,
    "default_width": 900
  },
  {
    "name": "2D Wardrobe - I",
    "sku": "0109",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0109.png",
    "default_height": 2100,
    "default_width": 900
  },
  {
    "name": "2D Wardrobe - J",
    "sku": "0110",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0110.png",
    "default_height": 2100,
    "default_width": 900
  },
  {
    "name": "2D Wardrobe - K",
    "sku": "0111",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0111.png",
    "default_height": 2100,
    "default_width": 900
  },
  {
    "name": "2D Wardrobe - L",
    "sku": "0112",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0112.png",
    "default_height": 2100,
    "default_width": 900
  },
  {
    "name": "2D Wardrobe - M",
    "sku": "0113",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0113.png",
    "default_height": 2100,
    "default_width": 900
  },
  {
    "name": "2D Wardrobe - O",
    "sku": "0114",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0114.png",
    "default_height": 2100,
    "default_width": 900
  },
  {
    "name": "2D Wardrobe - P",
    "sku": "0115",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0115.png",
    "default_height": 2100,
    "default_width": 900
  },
  {
    "name": "2D Wardrobe - Q",
    "sku": "0116",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0116.png",
    "default_height": 2100,
    "default_width": 900
  },
  {
    "name": "1D Wardrobe - A",
    "sku": "0201",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0201.png",
    "default_height": 2100,
    "default_width": 450
  },
  {
    "name": "1D Wardrobe - B",
    "sku": "0202",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0202.png",
    "default_height": 2100,
    "default_width": 450
  },
  {
    "name": "1D Wardrobe - C",
    "sku": "0203",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0203.png",
    "default_height": 2100,
    "default_width": 450
  },
  {
    "name": "1D Wardrobe - D",
    "sku": "0204",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0204.png",
    "default_height": 2100,
    "default_width": 450
  },
  {
    "name": "1D Wardrobe - E",
    "sku": "0205",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0205.png",
    "default_height": 2100,
    "default_width": 450
  },
  {
    "name": "1D Wardrobe - F",
    "sku": "0206",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0206.png",
    "default_height": 2100,
    "default_width": 450
  },
  {
    "name": "1D Wardrobe - G",
    "sku": "0207",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0207.png",
    "default_height": 2100,
    "default_width": 450
  },
  {
    "name": "2 Door Sliding Wardrobe",
    "sku": "0301",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0301.png",
    "default_height": 2100,
    "default_width": 2000
  },
  {
    "name": "3 Door Sliding Wardrobe",
    "sku": "0302",
    "category": "Wardrobe",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0302.png",
    "default_height": 2100,
    "default_width": 2400
  },
  {
    "name": "1D Floor Unit",
    "sku": "0401",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0401.png",
    "default_height": 800,
    "default_width": 450
  },
  {
    "name": "2D Floor Unit",
    "sku": "0402",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0402.png",
    "default_height": 800,
    "default_width": 900
  },
  {
    "name": "1D Sink Unit",
    "sku": "0403",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0403.png",
    "default_height": 800,
    "default_width": 450
  },
  {
    "name": "2D Sink Unit",
    "sku": "0404",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0404.png",
    "default_height": 800,
    "default_width": 900
  },
  {
    "name": "1D Cylinder Unit",
    "sku": "0405",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0405.png",
    "default_height": 800,
    "default_width": 450
  },
  {
    "name": "2D Cylinder Unit",
    "sku": "0406",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0406.png",
    "default_height": 800,
    "default_width": 900
  },
  {
    "name": "1 Tandem Box Unit",
    "sku": "0407",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0407.png",
    "default_height": 800,
    "default_width": 750
  },
  {
    "name": "2 Tandem Box Unit",
    "sku": "0408",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0408.png",
    "default_height": 800,
    "default_width": 750
  },
  {
    "name": "3 Tandem Box Unit",
    "sku": "0409",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0409.png",
    "default_height": 800,
    "default_width": 750
  },
  {
    "name": "Bottle Pullout Unit",
    "sku": "0410",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0410.png",
    "default_height": 800,
    "default_width": 300
  },
  {
    "name": "1 Wire Basket Unit",
    "sku": "0411",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0407.png",
    "default_height": 800,
    "default_width": 750
  },
  {
    "name": "2 Wire Basket Unit",
    "sku": "0412",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0408.png",
    "default_height": 800,
    "default_width": 750
  },
  {
    "name": "3 Wire Basket Unit",
    "sku": "0413",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0409.png",
    "default_height": 800,
    "default_width": 750
  },
  {
    "name": "1 Wicker Basket Unit",
    "sku": "0414",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0414.png",
    "default_height": 800,
    "default_width": 750
  },
  {
    "name": "2 Wicker Basket Unit",
    "sku": "0415",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0415.png",
    "default_height": 800,
    "default_width": 750
  },
  {
    "name": "3 Wicker Basket Unit",
    "sku": "0416",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0416.png",
    "default_height": 800,
    "default_width": 750
  },
  {
    "name": "4 Wicker Basket Unit",
    "sku": "0417",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0417.png",
    "default_height": 800,
    "default_width": 750
  },
  {
    "name": "1D Right Blind Corner Unit",
    "sku": "0418",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0418.png",
    "default_height": 800,
    "default_width": 1050
  },
  {
    "name": "1D Left Blind Corner Unit",
    "sku": "0419",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0419.png",
    "default_height": 800,
    "default_width": 1050
  },
  {
    "name": "1D Kitchen Frame & Shutter",
    "sku": "0420",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0420.png",
    "default_height": 800,
    "default_width": 450
  },
  {
    "name": "2D Kitchen Frame & Shutter",
    "sku": "0421",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0421.png",
    "default_height": 800,
    "default_width": 900
  },
  {
    "name": "Kitchen 1D Tall Unit",
    "sku": "0422",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0422.png",
    "default_height": 2100,
    "default_width": 450
  },
  {
    "name": "Kitchen 2D Tall Unit",
    "sku": "0423",
    "category": "Kitchen Base",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0423.png",
    "default_height": 2100,
    "default_width": 900
  },
  {
    "name": "1D Wall Unit",
    "sku": "0501",
    "category": "Kitchen Wall",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0501.png",
    "default_height": 600,
    "default_width": 400
  },
  {
    "name": "2D Wall Unit",
    "sku": "0502",
    "category": "Kitchen Wall",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0502.png",
    "default_height": 600,
    "default_width": 800
  },
  {
    "name": "1D Flap Unit",
    "sku": "0503",
    "category": "Kitchen Wall",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0503.png",
    "default_height": 600,
    "default_width": 400
  },
  {
    "name": "2D Flap Unit",
    "sku": "0504",
    "category": "Kitchen Wall",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0504.png",
    "default_height": 600,
    "default_width": 800
  },
  {
    "name": "Spice Rack",
    "sku": "0505",
    "category": "Kitchen Wall",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0505.png",
    "default_height": 200,
    "default_width": 800
  },
  {
    "name": "1 Door RO Kitchen Wall Unit",
    "sku": "0506",
    "category": "Kitchen Wall",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1001.png",
    "default_height": 600,
    "default_width": 400
  },
  {
    "name": "2 Door RO Kitchen Wall Unit",
    "sku": "0507",
    "category": "Kitchen Wall",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1002.png",
    "default_height": 600,
    "default_width": 800
  },
  {
    "name": "2D Loft",
    "sku": "0801",
    "category": "Loft",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0801.png",
    "default_height": 800,
    "default_width": 900
  },
  {
    "name": "1D Loft",
    "sku": "0802",
    "category": "Loft",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/0802.png",
    "default_height": 800,
    "default_width": 450
  },
  {
    "name": "1 Door Unit",
    "sku": "1001",
    "category": "Other",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1001.png",
    "default_height": 750,
    "default_width": 400
  },
  {
    "name": "2 Door Unit",
    "sku": "1002",
    "category": "Other",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1002.png",
    "default_height": 750,
    "default_width": 800
  },
  {
    "name": "3 Door Unit",
    "sku": "1003",
    "category": "Other",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1003.png",
    "default_height": 750,
    "default_width": 1200
  },
  {
    "name": "4 Door Unit",
    "sku": "1004",
    "category": "Other",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1004.png",
    "default_height": 750,
    "default_width": 1600
  },
  {
    "name": "1 Drawer",
    "sku": "1005",
    "category": "Other",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1005.png",
    "default_height": 200,
    "default_width": 600
  },
  {
    "name": "2 Drawer",
    "sku": "1006",
    "category": "Other",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1006.png",
    "default_height": 400,
    "default_width": 600
  },
  {
    "name": "2 Drawer",
    "sku": "1007",
    "category": "Other",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1007.png",
    "default_height": 200,
    "default_width": 1200
  },
  {
    "name": "3 Drawer",
    "sku": "1008",
    "category": "Other",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1008.png",
    "default_height": 600,
    "default_width": 600
  },
  {
    "name": "3 Drawer",
    "sku": "1009",
    "category": "Other",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1009.png",
    "default_height": 200,
    "default_width": 1800
  },
  {
    "name": "4 Drawer",
    "sku": "1010",
    "category": "Other",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1010.png",
    "default_height": 800,
    "default_width": 600
  },
  {
    "name": "4 Drawer",
    "sku": "1011",
    "category": "Other",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1011.png",
    "default_height": 200,
    "default_width": 1200
  },
  {
    "name": "1 Door Unit with Top Drawers ",
    "sku": "1012",
    "category": "Other",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1012.png",
    "default_height": 800,
    "default_width": 450
  },
  {
    "name": "1 Door Unit with Top Drawers",
    "sku": "1013",
    "category": "Other",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1013.png",
    "default_height": 800,
    "default_width": 450
  },
  {
    "name": "2 Door Unit with Top Drawers",
    "sku": "1014",
    "category": "Other",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1014.png",
    "default_height": 800,
    "default_width": 900
  },
  {
    "name": "2 Door Unit with Top Drawers",
    "sku": "1015",
    "category": "Other",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1015.png",
    "default_height": 800,
    "default_width": 900
  },
  {
    "name": "1D Wardrobe Frame & Shutter",
    "sku": "1101",
    "category": "Wardrobe F&S",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1101.png",
    "default_height": 2100,
    "default_width": 450
  },
  {
    "name": "2D Wardrobe Frame & Shutter",
    "sku": "1102",
    "category": "Wardrobe F&S",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1102.png",
    "default_height": 2100,
    "default_width": 900
  },
  {
    "name": "Default Carcass",
    "sku": "1201",
    "category": "Carcass Only",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1201.png",
    "default_height": 1500,
    "default_width": 450
  },
  {
    "name": "Default Open Box",
    "sku": "1202",
    "category": "Carcass Only",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1202.png",
    "default_height": 1500,
    "default_width": 450
  },
  {
    "name": "Default Frame Carcass",
    "sku": "1203",
    "category": "Carcass Only",
    "module_type": "box",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1203.png",
    "default_height": 1500,
    "default_width": 450
  },
  {
    "name": "Left End Panel (18mm)",
    "sku": "1301",
    "category": "Panel",
    "module_type": "shutter_panel",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1301.png",
    "default_height": 900,
    "default_width": 900
  },
  {
    "name": "Right End Panel (18mm)",
    "sku": "1302",
    "category": "Panel",
    "module_type": "shutter_panel",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1302.png",
    "default_height": 900,
    "default_width": 900
  },
  {
    "name": "Top End Panel (18mm)",
    "sku": "1303",
    "category": "Panel",
    "module_type": "shutter_panel",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1303.png",
    "default_height": 900,
    "default_width": 900
  },
  {
    "name": "Bottom End Panel (18mm)",
    "sku": "1304",
    "category": "Panel",
    "module_type": "shutter_panel",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1304.png",
    "default_height": 900,
    "default_width": 900
  },
  {
    "name": "Double Side Color Panel - Horizontal (18mm)",
    "sku": "1305",
    "category": "Panel",
    "module_type": "shutter_panel",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1305.png",
    "default_height": 900,
    "default_width": 900
  },
  {
    "name": "Double Side Color Panel - Vertical (18mm)",
    "sku": "1306",
    "category": "Panel",
    "module_type": "shutter_panel",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1306.png",
    "default_height": 900,
    "default_width": 900
  },
  {
    "name": "Back Panel - Flat (8mm)",
    "sku": "1307",
    "category": "Panel",
    "module_type": "carcass_panel",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1307.png",
    "default_height": 900,
    "default_width": 900
  },
  {
    "name": "Carcass Panel - Vertical (18mm)",
    "sku": "1308",
    "category": "Panel",
    "module_type": "carcass_panel",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1308.png",
    "default_height": 900,
    "default_width": 900
  },
  {
    "name": "Carcass Panel - Horizontal (18mm)",
    "sku": "1309",
    "category": "Panel",
    "module_type": "carcass_panel",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1309.png",
    "default_height": 900,
    "default_width": 900
  },
  {
    "name": "Carcass Panel - Flat (18mm)",
    "sku": "1310",
    "category": "Panel",
    "module_type": "carcass_panel",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1310.png",
    "default_height": 900,
    "default_width": 900
  },
  {
    "name": "Vertical Ledge - Left Exposed (27mm)",
    "sku": "1401",
    "category": "Panel",
    "module_type": "shutter_panel",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1401.png",
    "default_height": 900,
    "default_width": 900
  },
  {
    "name": "Vertical Ledge - Right Exposed (27mm)",
    "sku": "1402",
    "category": "Panel",
    "module_type": "shutter_panel",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1402.png",
    "default_height": 900,
    "default_width": 900
  },
  {
    "name": "Ledge - Top Exposed (27mm)",
    "sku": "1403",
    "category": "Panel",
    "module_type": "shutter_panel",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1403.png",
    "default_height": 900,
    "default_width": 900
  },
  {
    "name": "Ledge - Bottom Exposed (27mm)",
    "sku": "1404",
    "category": "Panel",
    "module_type": "shutter_panel",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1404.png",
    "default_height": 900,
    "default_width": 900
  },
  {
    "name": "Ledge - Double Side Exposed (27mm)",
    "sku": "1405",
    "category": "Panel",
    "module_type": "shutter_panel",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1405.png",
    "default_height": 900,
    "default_width": 900
  },
  {
    "name": "Vertical Ledge - Double Side Exposed (27mm)",
    "sku": "1406",
    "category": "Panel",
    "module_type": "shutter_panel",
    "image": "https://boxs-app.s3.ap-south-1.amazonaws.com/product_images/new/1406.png",
    "default_height": 900,
    "default_width": 900
  }
];

export default sampleProducts;